/* THE JERKY — Halloween «Trick or Meat» (SHOP-485, preview copy of the theme only): countdown, copy the code,
   flashlight, the Trick-or-Meat game, the video window, and pausing effects that are off screen. No libraries. */
(function () {
  var cfg = window.tjHalloween || {};
  var code = cfg.code || 'BOO13';
  var end = Date.parse(cfg.end || '');
  var root = document.documentElement;

  // Countdown to the end of the code (Riga time in the setting); afterwards every [data-tjh-promo] element hides itself.
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var timer = null;
  function tick() {
    if (!isFinite(end)) return;
    var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
    if (s === 0) { root.classList.add('tjh-expired'); if (timer) clearInterval(timer); }
    var d = Math.floor(s / 86400); s %= 86400;
    var h = Math.floor(s / 3600); s %= 3600;
    var m = Math.floor(s / 60); s %= 60;
    var txt = (d ? d + (cfg.day || 'D') + ' ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
    var els = document.querySelectorAll('[data-tjh-countdown]');
    for (var i = 0; i < els.length; i++) if (els[i].textContent !== txt) els[i].textContent = txt;
  }

  // Copy the code (any [data-tjh-copy]) + a short message
  var toastEl = null, toastT = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'tjh tjh-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('tjh-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('tjh-on'); }, 2600);
  }
  function fallbackCopy() {
    var ta = document.createElement('textarea');
    ta.value = code; ta.setAttribute('readonly', ''); ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
    document.body.appendChild(ta); ta.select();
    var ok = false; try { ok = document.execCommand('copy'); } catch (e) {}
    ta.remove();
    return ok;
  }
  function copyCode() {
    var done = function (ok) { toast(ok ? (cfg.copied || ('Code ' + code + ' copied')) : (cfg.yourCode || ('Your code: ' + code))); };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(function () { done(true); }, function () { done(fallbackCopy()); });
    else done(fallbackCopy());
  }

  // Flashlight: follows the mouse; on touch screens it keeps sweeping by itself (CSS)
  function initTorch(hero) {
    var torch = hero.querySelector('[data-tjh-torch]');
    if (!torch) return;
    var frame = 0, x = 0, y = 0;
    hero.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      x = e.clientX; y = e.clientY;
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = 0;
        var r = torch.getBoundingClientRect();
        torch.classList.remove('tjh-sway');
        torch.style.setProperty('--tjh-fx', (x - r.left) + 'px');
        torch.style.setProperty('--tjh-fy', (y - r.top) + 'px');
        hero.classList.add('tjh-moved');
      });
    });
  }

  // Spider (owner 23.10: «чтобы паучка можно было и нажатием тянуть вниз», «оттягивался отлетая обратно», then «и на телефоне
  // … и на все зоны куда дотянуть можно»): grab its body or tag with a mouse, finger or pen and pull it anywhere its thread
  // reaches — down, sideways, almost level with where it hangs from; let go and it snaps back like on a rubber band, flies past
  // its place and swings a few times. A short press on the tag still copies the code.
  function initSpider(hero) {
    var sp = hero.querySelector('.tjh-spider');
    if (!sp) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var LIM = 85 * Math.PI / 180;   // the thread never goes above level
    var drag = null, moved = false, raf = 0, y = 0, r = 0, vy = 0, vr = 0;
    // y = how much longer the thread is than at rest, r = its angle in degrees (both turn around the hanging point)
    function place() {
      sp.style.transformOrigin = '50% ' + (-y).toFixed(1) + 'px';
      sp.style.transform = 'translateY(' + y.toFixed(1) + 'px) rotate(' + r.toFixed(2) + 'deg)';
    }
    function rest() { y = 0; r = 0; vy = 0; vr = 0; sp.style.transform = ''; sp.style.transformOrigin = ''; }
    // the body's centre below the hanging point, from its CSS (an <svg> has no offsetTop; rects would include the swing)
    function bodyY() {
      var b = sp.querySelector('svg'), cs = b && getComputedStyle(b);
      var v = cs ? parseFloat(cs.top) + parseFloat(cs.height) / 2 : NaN;
      return isFinite(v) ? v : 164;
    }
    // elastic thread: stiff and lightly damped (damping ratio ≈ 0.24) — snaps back, overshoots, 2–3 swings, still in ~1.5 s
    function settle() {
      cancelAnimationFrame(raf);
      if (reduce.matches) { rest(); return; }
      var last = performance.now();
      var step = function (now) {
        var dt = Math.min(0.02, (now - last) / 1000); last = now;
        vy += (-340 * y - 9 * vy) * dt; y += vy * dt;
        vr += (-340 * r - 9 * vr) * dt; r += vr * dt;
        if (Math.abs(y) < 0.3 && Math.abs(vy) < 4 && Math.abs(r) < 0.1 && Math.abs(vr) < 1) { rest(); return; }
        place(); raf = requestAnimationFrame(step);
      };
      raf = requestAnimationFrame(step);
    }
    sp.addEventListener('pointerdown', function (e) {
      var grip = e.target.closest('svg, .tjh-tag');
      if (!grip || e.button !== 0) return;
      // mouse: no text selection or picture drag (CSS covers touch — on a finger this would also cancel the tap, so no copy)
      if (e.pointerType === 'mouse') e.preventDefault();
      cancelAnimationFrame(raf);
      if (sp.getAnimations) sp.getAnimations().forEach(function (a) { try { a.finish(); } catch (x) {} });
      var B = bodyY(), th = -r * Math.PI / 180, L = B + y;
      // where the body is now, measured from where it rests (it may be caught mid-swing)
      drag = { id: e.pointerId, x: e.clientX, y: e.clientY, B: B, max: Math.max(260, hero.offsetHeight * 0.95 - B),
               ox: L * Math.sin(th), oy: L * Math.cos(th) - B, t: performance.now(), py: y, pr: r };
      moved = false; vy = 0; vr = 0;
      try { grip.setPointerCapture(e.pointerId); } catch (x) {}
    });
    sp.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (!moved && Math.abs(dx) < 5 && Math.abs(dy) < 5) return;
      if (!moved) { moved = true; sp.classList.add('tjh-dragging'); }
      // the body goes where the hand is, as far as the thread reaches
      var px = drag.ox + dx, py = drag.B + drag.oy + dy;
      var th = Math.max(-LIM, Math.min(LIM, Math.atan2(px, py)));
      var ext = Math.hypot(px, py) - drag.B;
      y = ext > drag.max ? drag.max + (ext - drag.max) * 0.2 : (ext < -40 ? -40 + (ext + 40) * 0.25 : ext);
      y = Math.max(-60, y);
      r = -th * 180 / Math.PI;
      // the hand's speed carries into the release (a flick throws it further)
      var now = performance.now(), dtm = (now - drag.t) / 1000;
      if (dtm > 0.008) {
        vy = Math.max(-2500, Math.min(2500, 0.6 * vy + 0.4 * (y - drag.py) / dtm));
        vr = Math.max(-900, Math.min(900, 0.6 * vr + 0.4 * (r - drag.pr) / dtm));
        drag.t = now; drag.py = y; drag.pr = r;
      }
      place();
    });
    var end = function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      if (performance.now() - drag.t > 80) { vy = 0; vr = 0; }   // held still before letting go: no throw
      drag = null;
      sp.classList.remove('tjh-dragging');
      if (moved) settle();
    };
    sp.addEventListener('pointerup', end);
    sp.addEventListener('pointercancel', end);
    sp.addEventListener('lostpointercapture', end);   // released outside the window
    // a pull is not a click on the tag
    sp.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  }

  // Trick or Meat
  function initGame(tom) {
    var msg = tom.querySelector('.tjh-tom-msg');
    tom.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tjh-pick]');
      if (!b) return;
      var meat = b.getAttribute('data-tjh-pick') === 'meat';
      tom.classList.remove('is-trick', 'is-meat');
      void tom.offsetWidth;
      tom.classList.add(meat ? 'is-meat' : 'is-trick');
      if (msg) msg.textContent = b.getAttribute('data-tjh-msg') || '';
      if (meat) {
        var copyBtn = tom.querySelector('.tjh-coupon [data-tjh-copy]');
        if (copyBtn) setTimeout(function () { copyBtn.focus({ preventScroll: true }); }, 900);
      }
    });
  }

  // The site video in a window: the Shopify video of this language (phones: the 9:16 cut when there is one)
  function openVideo(btn) {
    var phone = window.matchMedia('(max-width: 749px)').matches;
    var src = (phone && btn.getAttribute('data-src-m')) || btn.getAttribute('data-src');
    if (!src) return;
    var dlg = document.createElement('dialog');
    dlg.className = 'tjh tjh-dialog' + (phone && btn.getAttribute('data-src-m') ? ' tjh-dialog--m' : '');
    dlg.setAttribute('aria-label', btn.getAttribute('aria-label') || 'Video');
    var close = document.createElement('button');
    close.type = 'button'; close.className = 'tjh-close'; close.setAttribute('aria-label', btn.getAttribute('data-close') || 'Close'); close.textContent = '×';
    var v = document.createElement('video');
    v.src = src; v.controls = true; v.playsInline = true; v.preload = 'auto';
    var poster = (phone && btn.getAttribute('data-poster-m')) || btn.getAttribute('data-poster');
    if (poster) v.poster = poster;
    dlg.appendChild(close); dlg.appendChild(v);
    document.body.appendChild(dlg);
    var shut = function () { try { v.pause(); } catch (e) {} if (dlg.open) dlg.close(); };
    close.addEventListener('click', shut);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) shut(); });
    dlg.addEventListener('close', function () { v.removeAttribute('src'); v.load(); dlg.remove(); btn.focus({ preventScroll: true }); });
    dlg.showModal();
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-tjh-copy]');
    if (c) { e.preventDefault(); copyCode(); return; }
    var v = e.target.closest('[data-tjh-video]');
    if (v) { e.preventDefault(); openVideo(v); }
  });

  // Effects run only while their section is on screen
  function initPause() {
    var els = document.querySelectorAll('[data-tjh-anim]');
    if (!('IntersectionObserver' in window) || !els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { en.target.classList.toggle('tjh-off', !en.isIntersecting); });
    }, { rootMargin: '80px 0px' });
    for (var i = 0; i < els.length; i++) io.observe(els[i]);
  }

  // Long translations: the big one-line plates (game title, video lines) that do not fit their column get one smaller
  // font size for the whole group, so stacked plates stay alike; never larger than the design size.
  function fitPlates() {
    var groups = document.querySelectorAll('.tjh-tom-h, .tjh-promo-copy');
    for (var g = 0; g < groups.length; g++) {
      var box = groups[g].classList.contains('tjh-tom-h') ? groups[g].parentElement : groups[g];
      var plates = groups[g].querySelectorAll('.tjh-p-red, .tjh-p-beige');
      var bs = getComputedStyle(box), room = box.clientWidth - parseFloat(bs.paddingLeft) - parseFloat(bs.paddingRight) - 8, r = 1, i;
      for (i = 0; i < plates.length; i++) plates[i].style.fontSize = '';
      for (i = 0; i < plates.length; i++) {
        var ps = getComputedStyle(plates[i]), pad = parseFloat(ps.paddingLeft) + parseFloat(ps.paddingRight);
        var w = plates[i].getBoundingClientRect().width;
        if (w > room && w > pad) r = Math.min(r, (room - pad) / (w - pad));
      }
      if (r < 1) for (i = 0; i < plates.length; i++) plates[i].style.fontSize = Math.floor(parseFloat(getComputedStyle(plates[i]).fontSize) * r * 2) / 2 + 'px';
    }
  }

  function init() {
    fitPlates();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitPlates);
    var fitT = 0;
    window.addEventListener('resize', function () { cancelAnimationFrame(fitT); fitT = requestAnimationFrame(fitPlates); });
    tick();
    if (isFinite(end) && end > Date.now()) timer = setInterval(tick, 1000);
    var hero = document.querySelector('.tjh-hero');
    if (hero) { initTorch(hero); initSpider(hero); }
    var tom = document.querySelector('.tjh-tom');
    if (tom) initGame(tom);
    initPause();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
